import { openNativeOrWeb, isNativeApp } from "common/nativeRoute";
import { openRoleManage } from "common/nativeBridge";
import { callGetMyRoles, callGetRoleHeroImages } from "api/MuyeonApi";
import { showToast } from "util/appToast";

/**
 * 회원유형 설정/인증 진입.
 *  - 앱(네이티브): 웹 화면전환 없이 브릿지(openRoleManage)만 호출 → 네이티브 넷플릭스식 관리 화면.
 *    역할데이터 + 히어로 배경(서버 랜덤 1장)을 실어 전달.
 *  - 웹: 대응 화면이 없다(구 /memberSwitch 는 2026-07-30 폐기) → 앱 설치 유도 안내.
 *    종전에는 아무 반응이 없어 죽은 버튼으로 보였다.
 */
// 호출부가 활성유형을 안 넘기면(공고 작성·구인구직 등) 네이티브 화면이 '일반'을 선택된 것으로 그려
// 강사로 바꿔 둔 회원도 '일반으로 돌아갔다'고 보였다 — 현재 활성유형(AuthContext 저장값)을 기본으로 쓴다.
const currentActiveType = () => {
  try { return localStorage.getItem("muyeon.activeType") || "GENERAL"; } catch (e) { return "GENERAL"; }
};

export const openMemberType = async (navigate, activeType = currentActiveType()) => {
  let roles = null;
  let heroImage = "";
  // 역할·히어로 이미지는 네이티브 화면에만 필요하므로 앱에서만 조회한다.
  if (isNativeApp()) {
    try {
      const rr = await callGetMyRoles();
      roles = rr?.data ?? null;
      try {
        const hr = await callGetRoleHeroImages();
        heroImage = hr?.data?.image || "";
      } catch (e) { /* noop */ }
    } catch (e) { /* noop */ }
    // ★ 2026-10-19 조회 실패 시 빈 역할로 열면 이미 보유한 유형도 전부 '추가'로 보여 추가 팝업이 반복됐다.
    if (!Array.isArray(roles?.held)) {
      showToast("회원유형 정보를 불러오지 못했어요. 잠시 후 다시 시도해 주세요.");
      return;
    }
  }
  if (!roles) roles = { held: [], roles: [] };
  openNativeOrWeb(openRoleManage, { roles, heroImage, activeType }, navigate);
};
